import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationStart, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';
import { SharedUiModule } from '@stc-apps/shared-ui';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ApiTestIconComponent } from 'apps/aquila/src/assets/icons/api-test-icon/api-test-icon.component';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { SecurityIconComponent } from 'apps/aquila/src/assets/icons/security-icon/security-icon.component';
import { TopBannerComponent } from '../components/top-banner/top-banner.component';
import { LoaderService } from '../../core/services/loader.service';
import { LoaderComponent } from '../components/loader/loader.component';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { PresentionIconComponent } from 'apps/aquila/src/assets/icons/presention-icon/presention-icon.component';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { SettingsIconComponent } from 'apps/aquila/src/assets/icons/settings-icon/settings-icon.component';
import { ThemeService } from '../../core/services/theme.service';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { SidebarLinksModel } from 'libs/shared-ui/src/lib/sidebar/sidebarLinks.model';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AiAssistantIconComponent } from 'apps/aquila/src/assets/icons/ai-assistant-icon/ai-assistant-icon.component';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { TestHistoryIconComponent } from 'apps/aquila/src/assets/icons/clock-icon/clock-icon.component';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AuditTrailIconComponent } from 'apps/aquila/src/assets/icons/audit-trail-icon/audit-trail-icon.component';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { RepositoryIconComponent } from 'apps/aquila/src/assets/icons/repository-icon/repository-icon.component';
import { AuthService } from '../../features/auth/services/auth.service';
import { NavigationSidebarComponent } from '../../shared/components/navigation-sidebar/navigation-sidebar.component';

@Component({
  selector: 'stc-apps-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SharedUiModule,
    RouterModule,
    TopBannerComponent,
    LoaderComponent,
    NavigationSidebarComponent,
    AuditTrailIconComponent,
  ],
})
export class MainLayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  loaderService = inject(LoaderService);
  private readonly themeService = inject(ThemeService);
  cdr = inject(ChangeDetectorRef);
  router = inject(Router);
  private authService = inject(AuthService);
  private destroyRef = inject(DestroyRef);
  username!: string;
  userRole!: string;
  logoSrc!: string;
  isAllowed!: boolean;
  isSidebarVisible = false;
  private mediaQuery?: MediaQueryList;
  private mediaQueryListener?: (event: MediaQueryListEvent) => void;
  private readonly mobileBreakpoint = 768;
  private readonly adminEmails = new Set(['admin@qeema.net']);
  toggleSidebar(event: boolean) {
    this.isSidebarVisible = event;
    this.themeService.isSidebarClosed.next(!event);
  }

  ngAfterViewInit(): void {
    this.mediaQuery = window.matchMedia(
      `(min-width: ${this.mobileBreakpoint}px)`
    );
    this.mediaQueryListener = (event: MediaQueryListEvent) => {
      if (!event.matches) {
        this.isSidebarVisible = false;
        this.themeService.isSidebarClosed.next(true);
      }
    };
    this.mediaQuery.addEventListener('change', this.mediaQueryListener);
  }
  isApiTestUrl = false;
  ngOnInit(): void {
    // this.isApiTestUrl = this.router.url.includes('api-test');
    // get the url using subscribe to router events and check if it contains 'api-test'
    this.router.events.subscribe((event: any) => {
      this.isApiTestUrl = event.routerEvent?.url?.includes('api-test') || false;
    });

    this.logoSrc = this.themeService.getAppLogoPath();
    this.navItems = this.buildNavItems();
    this.themeService.isSidebarClosed
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isClosed) => {
        this.isSidebarVisible = !isClosed;
      });
    this.themeService.appLogoPath$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((path) => {
        this.logoSrc = path;
      });
    this.isSidebarVisible = false;

    this.router.events
      .pipe(
        filter(
          (event): event is NavigationStart => event instanceof NavigationStart
        ),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        if (window.innerWidth <= this.mobileBreakpoint) {
          this.isSidebarVisible = false;
        }
      });
    this.userRole = localStorage.getItem('userType') || '';
    this.username = localStorage.getItem('username') || '';
  }

  ngOnDestroy(): void {
    if (this.mediaQuery && this.mediaQueryListener) {
      this.mediaQuery.removeEventListener('change', this.mediaQueryListener);
    }
  }

  navItems: SidebarLinksModel[] = [];

  private buildNavItems(): SidebarLinksModel[] {
    const links: SidebarLinksModel[] = [];
    const role = localStorage.getItem('userType') || '';
    //role === 'components_admin
    if (role === 'app_admin') {
      links.push(
        {
          id: 6,
          name: 'Dashboard',
          url: '',
        },

        {
          id: 2,
          name: 'OPEN API Standard',
          url: 'api-standards',
          iconPath: SecurityIconComponent,
        },
        {
          id: 3,
          name: 'User management',
          url: 'user-management',
          iconPath: PresentionIconComponent,
        },
        {
          id: 5,
          name: 'Audit Trail',
          url: 'audit-trail',
          iconPath: AuditTrailIconComponent,
        }
        // {
        //   id: 4,
        //   name: 'Repository',
        //   url: 'repository',
        //   iconPath: RepositoryIconComponent,
        // },
        // {
        //   id: 0,
        //   name: 'API test',
        //   url: 'api-test',
        //   iconPath: ApiTestIconComponent,
        // },
        // {
        //   id: 1,
        //   name: 'Test history',
        //   url: 'api-history',
        //   iconPath: TestHistoryIconComponent,
        // }
        // {
        //   id: 4,
        //   name: 'Settings',
        //   url: 'settings',
        //   iconPath: SettingsIconComponent,
        // }
      );
    } else {
      links.push(
        {
          id: 6,
          name: 'Dashboard',
          url: '',
        },
        {
          id: 0,
          name: 'API test',
          url: 'api-test',
          iconPath: ApiTestIconComponent,
        },
        {
          id: 1,
          name: 'Test history',
          url: 'api-history',
          iconPath: TestHistoryIconComponent,
        },
        {
          id: 4,
          name: 'Repository',
          url: 'repository',
          iconPath: RepositoryIconComponent,
        }
        // {
        //   id: 2,
        //   name: 'OPEN API Standard',
        //   url: 'api-standard-list',
        //   iconPath: SecurityIconComponent,
        //   imgUrl: 'assets/icons/security-icon.svg',
        // },
        // {
        //   id: 3,
        //   name: 'Activity Monitoring',
        //   url: 'activity-monitoring',
        //   iconPath: PresentionIconComponent,
        //   imgUrl: 'assets/icons/presention-icon.svg',
        // },
        // {
        //   id: 4,
        //   name: 'User management',
        //   url: 'user-management',
        //   iconPath: PresentionIconComponent,
        //   imgUrl: 'assets/icons/presention-icon.svg',
        // },
        // {
        //   id: 5,
        //   name: 'Ai Assistant',
        //   url: 'https://mso-dev.tools.qeema.io/',
        //   iconPath: AiAssistantIconComponent,
        //   imgUrl: 'assets/icons/ai-assistant.svg',
        // },
      );
    }

    return links;
  }
  logout() {
    this.authService.logout();
  }
  private isAdminEmail(): boolean {
    const userEmail =
      localStorage.getItem('userEmail')?.trim().toLowerCase() ?? '';
    return this.adminEmails.has(userEmail);
  }

  onNotification() {}

  onLogout() {}
}
